import styled from 'styled-components';

export const Container = styled.ul`
    margin-top: 20px;
    padding-inline-start: 0;

    li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #444;

        & + li {
            margin-top: 15px;
        }

        div {
            display: flex;

            a {
                display: flex;
                align-items: center;
            }
        }
    }
`;

export const FileInfo = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const Preview = styled.div`
    width: 100px;
    height: 100px;
    border-radius: 5px;
    background-image: url(${props => props.src});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    margin-right: 10px;
`;